import React from "react";
import {
  Box,
  FormControlLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import {
  HtmlTooltip,
  StyledDarkRedInformationTypography,
  StyledInfoBox,
  StyledInformationSpan,
  StyledMainBox,
  StyledSwitch,
} from "../../../components/commonComponents/StyledComponents/styled";
import DateInputField from "../../../components/commonComponents/TextInputs/DateInputs";
import { BlockOutlined, Close, Info, PlayArrow, Save } from "@mui/icons-material";
import CloseButton from "../../../components/commonComponents/Buttons/CloseButton";
import ActionButton from "../../../components/commonComponents/Buttons/ActionButton";
import { loadCampaignsForUsers, getStoresAvailableHours, fetchCampaignNames } from "../../../api_calls/campaignRequests";
import { useDispatch, useSelector } from "react-redux";
import { loadActivStoresFromCampaign, saveClipsInformation } from "../../../api_calls/clipRequests";
import { deleteItems, updateStateData } from "../../../Store/actions";
import {
  checkStatus,
  fetchWeekNumbers,
  formatToStandardDate,
  standardFormatToday,
  isValidFileName,
  allWeekDayOptions,
  clampDate
} from "../../../api_calls/utils";
import StoreHierarchy from "./StoreHierarchy";
import ErrorMessageText from "../../../components/commonComponents/Errors/ErrorMessageText";
import SingleSelect from "../../../components/commonComponents/Selectors/SingleSelect";
import NoSortMultiSelect from "../../../components/commonComponents/Selectors/NoSortMultiSelect";
import moment from "moment-timezone";
import {
  DarkRedActionButton,
  LightGreyActionButton,
} from "../../../components/commonComponents/Buttons/Styles";
import Confirmation from "../../../components/commonComponents/Confirmation";
import { toast } from "react-toastify";
import { checkUserDetailsFromCookie, fetchStoreLevelCompanies } from "../../../api_calls/userManagement";
import { useDropzone } from "react-dropzone";
import DetailSearchContactBasedVisualStores from "./DetailSearchContactBasedVisualStores";
import TextInputField from "../../../components/commonComponents/TextInputs/TextInputField";
import { setBatchLoadingStatus } from "../../../api_calls/requestConfig";
// import { set } from "immer/dist/internal.js";

const AddNewClip = ({ open, onClose, size, usedFor, closeModal, clipInfo, setClipInfo }) => {

  const [isDetailSelectionModalOpen, setIsDetailSelectionModalOpen] = React.useState(false);
  const [storePreselection, setStorePreselection] = React.useState([])

  const currentStateData = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const campaignNameListOptions =
    typeof currentStateData.exclusive_campaign_list !== "undefined" &&
      typeof currentStateData.exclusive_campaign_list.active_campaign_name_list !== "undefined"
      ? currentStateData.exclusive_campaign_list.active_campaign_name_list
      : [];
  const campaignDatesList =
    typeof currentStateData.campaign_names_info !== "undefined" &&
      typeof currentStateData.campaign_names_info.campaign_dates_list !== "undefined"
      ? currentStateData.campaign_names_info.campaign_dates_list
      : [];
  const datesNotSelected =
    !currentStateData.new_clip_data?.clip_start_date ||
    !currentStateData.new_clip_data?.clip_end_date;
  const mapWeekdaysToNumbers = (weekdayOptions) => {
    const weekdayMap = {
      "Sunday": 0,
      "Monday": 1,
      "Tuesday": 2,
      "Wednesday": 3,
      "Thursday": 4,
      "Friday": 5,
      "Saturday": 6,
    };

    return weekdayOptions
      .map(opt => weekdayMap[opt.label])
      .filter(num => num !== undefined);
  };
  const [fieldErrors, setFieldErrors] = React.useState({});
  const [minSelectableDateForClip, setMinSelectableDateForClip] = React.useState(standardFormatToday());
  const [showStartDateConfirmation, setStartDateConfirmation] = React.useState(false);
  const [showEndDateConfirmation, setEndDateConfirmation] = React.useState(false);
  const [showPlayoutStopConfirmation, setShowPlayoutStopConfirmation] = React.useState(false);
  const [showContinuePlayoutConfirmation, setShowContinuePlayoutConfirmation] = React.useState(false);
  const [hoursOptions, setHoursOptions] = React.useState([]);
  const [weekdayOptions, setWeekdayOptions] = React.useState([]);

  const checkUserDetails = checkUserDetailsFromCookie();
  let userDetailObj = {};
  if (checkUserDetails.success === true) {
    userDetailObj = checkUserDetails.user_detail;
  }
  const [userInfo, setUserInfo] = React.useState(userDetailObj);

  const [acceptedFiles, setAcceptedFiles] = React.useState([]);
  const [invalidFiles, setInvalidFiles] = React.useState([]);
  const [rejectedFiles, setRejectedFiles] = React.useState([]);
  const [resolutionErrors, setResolutionErrors] = React.useState([]);
  const [fileDialogActive, setFileDialogActive] = React.useState(false);

  const prevClipStartDateRef = React.useRef(
    usedFor === "update" && clipInfo?.start_date
      ? formatToStandardDate(clipInfo.start_date)
      : (currentStateData.new_clip_data?.clip_start_date || null)
  );
  const prevClipEndDateRef = React.useRef(
    usedFor === "update" && clipInfo?.end_date
      ? formatToStandardDate(clipInfo.end_date)
      : (currentStateData.new_clip_data?.clip_end_date || null)
  );
  // const maxFileSize = 50 * 1024 * 1024;
  // const minFileInBytes = 6;
  // convert bytes into MB
  /* const convertToMb = (bytesValue) => {
    return (bytesValue / (1024 * 1024)).toFixed(2);
  }; */

  // set duplicated file details to be shown under rejected list
  const checkFileNameValidation = (newFiles) => {
    let discardedFiles = [];
    const validFile = newFiles.filter((file) => {
      const isValid = isValidFileName(file.name);
      if (!isValid) {
        discardedFiles.push(file);
      }
      return isValid;
    });

    setInvalidFiles([...discardedFiles]);

    return validFile.length !== 0 ? true : false;
  };

  // Check video resolution - must be exactly 1920x1080
  const checkVideoResolution = (file) => {
    return new Promise((resolve) => {
      const url = URL.createObjectURL(file);
      const video = document.createElement('video');

      video.onloadedmetadata = () => {
        URL.revokeObjectURL(url);
        const width = video.videoWidth;
        const height = video.videoHeight;

        if (width > 1920 || height > 1920) {
          resolve({ valid: false, width, height });
        } else {
          resolve({ valid: true });
        }
      };

      video.onerror = () => {
        URL.revokeObjectURL(url);
        resolve({ valid: false, error: 'Resolution too high. Resolution must not exceed 1920x1080px.' });
      };

      video.src = url;
    });
  };
  // drag drop config
  const maxFileSize = 200 * 1024 * 1024;
  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: {
      // 'image/png': ['.png'],
      // 'image/jpeg': ['.jpg', '.jpeg'],
      'video/mp4': ['.mp4'],
    },
    noDragEventsBubbling: true,
    maxSize: maxFileSize,
    onFileDialogOpen: () => {
      setFileDialogActive(true);
    },
    onFileDialogCancel: () => {
      setFileDialogActive(false); // reset when dialog is closed
    },
    // Disable drag while file dialog is open
    noDrag: fileDialogActive,
    onDrop: async (newFiles, fileRejections) => {
      setFileDialogActive(false);
      checkFileNameValidation(newFiles);

      // Validate file names first
      const validNameFiles = newFiles.filter((file) => isValidFileName(file.name));

      if (validNameFiles.length > 0) {
        // Check resolution for valid files
        const resolutionCheck = await checkVideoResolution(validNameFiles[0]);

        if (resolutionCheck.valid) {
          // Resolution is correct - accept the file
          setAcceptedFiles([validNameFiles[0]]);
          setResolutionErrors([]);
        } else {
          // Resolution is incorrect - reject the file
          const errorMsg = resolutionCheck.error
            ? resolutionCheck.error
            : 'Resolution too high. Resolution must not exceed 1920x1080px.';

          setAcceptedFiles([]);
          setResolutionErrors([{ file: validNameFiles[0], message: errorMsg }]);
        }
      } else {
        setAcceptedFiles([]);
        setResolutionErrors([]);
      }

      setRejectedFiles((prev) => [...fileRejections.map(({ file }) => file)]);
    },
  });

  const statusBasedReadOnly =
    typeof currentStateData.new_clip_data !== "undefined" &&
      typeof currentStateData.new_clip_data.clip_start_end_status !== "undefined" &&
      ["Completed"].includes(currentStateData.new_clip_data.clip_start_end_status)
      ? true
      : false;

  const handleFieldChange = (clipData, overwrite = false) => {
    const selectedClipData = overwrite === true ?
      {
        clip_unlimited: false, clip_volume: 190
      } :
      typeof currentStateData.new_clip_data !== "undefined" ? currentStateData.new_clip_data : {};
    dispatchAction(
      updateStateData({
        new_clip_data: { ...selectedClipData, ...clipData },
      })
    );
  };

  const calculateWeeks = (datesData) => {
    const clipStart = typeof datesData.clip_start_date !== "undefined" ? datesData.clip_start_date : "";
    const clipEnd = typeof datesData.clip_end_date !== "undefined" ? datesData.clip_end_date : "";
    let weeks = [];
    if (clipStart !== "" && clipEnd !== "") {
      weeks = fetchWeekNumbers(clipStart, clipEnd);
      // auto select all the weeks
    }
    return weeks;
  };

  // Week selection handler - sets dates based on field disabled states, clamped to campaign bounds
  const handleWeekSelect = React.useCallback((monday, sunday, fieldRole) => {
    const campaignStart = typeof currentStateData.new_clip_data !== "undefined" &&
      typeof currentStateData.new_clip_data.campaign_start_date !== "undefined"
      ? formatToStandardDate(currentStateData.new_clip_data.campaign_start_date)
      : null;

    const campaignEnd = typeof currentStateData.new_clip_data !== "undefined" &&
      typeof currentStateData.new_clip_data.campaign_end_date !== "undefined"
      ? formatToStandardDate(currentStateData.new_clip_data.campaign_end_date)
      : null;

    const isStartDisabled = typeof currentStateData.new_clip_data !== "undefined" &&
      typeof currentStateData.new_clip_data.clip_start_end_status !== "undefined" &&
      ["Active", "Completed"].includes(currentStateData.new_clip_data.clip_start_end_status);

    const isEndDisabled = typeof currentStateData.new_clip_data !== "undefined" &&
      typeof currentStateData.new_clip_data.clip_start_end_status !== "undefined" &&
      (["Completed"].includes(currentStateData.new_clip_data.clip_start_end_status) ||
        currentStateData.new_clip_data.active === false);

    if (isStartDisabled && isEndDisabled) {
      return;
    }

    // Constraints mirroring the start date field's minSelectable prop
    let startFieldMin = minSelectableDateForClip;
    if (campaignStart && campaignStart > startFieldMin) {
      startFieldMin = campaignStart;
    }
    const clampedStart = clampDate(monday, startFieldMin, campaignEnd);

    // Constraints mirroring the end date field's minSelectable IIFE:
    // if the resolved start date is today or later, end must be >= start;
    // otherwise fall back to the global minimum selectable date
    const today = standardFormatToday();
    const endFieldMin = clampedStart >= today ? clampedStart : minSelectableDateForClip;
    const clampedEnd = clampDate(sunday, endFieldMin, campaignEnd);

    if (clampedStart > clampedEnd) {
      return;
    }

    const updateData = {};

    if (fieldRole === "end") {
      // Week selected from the end date field: anchor end to Sunday, derive start from Monday
      if (!isEndDisabled) {
        updateData.clip_end_date = clampedEnd;
      }
      if (!isStartDisabled) {
        updateData.clip_start_date = clampedStart;
      }
    } else {
      // Week selected from the start date field: anchor start to Monday, derive end from Sunday
      if (!isStartDisabled) {
        updateData.clip_start_date = clampedStart;
      }
      if (!isEndDisabled) {
        updateData.clip_end_date = clampedEnd;
      }
    }

    if (Object.keys(updateData).length > 0) {
      handleFieldChange(updateData);

      calculateWeeks({
        clip_start_date: updateData.clip_start_date ??
          currentStateData.new_clip_data?.clip_start_date,
        clip_end_date: updateData.clip_end_date ??
          currentStateData.new_clip_data?.clip_end_date,
      });
    }
  }, [currentStateData.new_clip_data, minSelectableDateForClip]);

  // Global min/max for week selection styling (campaign bounds)
  const weekSelectionMin = React.useMemo(() => {
    return minSelectableDateForClip;
  }, [minSelectableDateForClip]);

  const weekSelectionMax = React.useMemo(() => {
    return typeof currentStateData.new_clip_data !== "undefined" &&
      typeof currentStateData.new_clip_data.campaign_end_date !== "undefined"
      ? formatToStandardDate(currentStateData.new_clip_data.campaign_end_date)
      : null;
  }, [currentStateData.new_clip_data?.campaign_end_date]);

  const setClipStartDateConstraint = (campaignStartDate) => {
    const today = standardFormatToday(); //moment().tz(platformConfig.timezone).startOf("day");
    const campaignStart = formatToStandardDate(campaignStartDate);
    // if campaign start date = today or campaign start date is in past, we have to add one day to the start date
    if (today.getTime() === campaignStart.getTime() || today > campaignStart) {
      // const nextDay = new Date(today);
      // nextDay.setDate(today.getDate() + 1);
      setMinSelectableDateForClip(today);
    }

    // campaign start date is in future
    if (campaignStart > today) {
      setMinSelectableDateForClip(campaignStart);
    }
  };

  // save/update clip information
  const saveUpdpateClipInfo = async (shouldClosePopup, showSuccessMessage) => {
    const contactsValue = currentStateData.new_clip_data?.clip_contacts;
    const isUnlimited = currentStateData.new_clip_data?.clip_unlimited;

    const isEmpty =
      typeof contactsValue === "undefined" ||
      contactsValue?.toString().trim() === "";

    const isValidNumber =
      !isEmpty &&
      /^\d+$/.test(contactsValue) &&
      Number(contactsValue) >= 1;

    if (
      !currentStateData.new_clip_data?.campaign_id ||
      (!isUnlimited && (isEmpty || !isValidNumber))
    ) {
      setFieldErrors({
        ...(!currentStateData.new_clip_data?.campaign_id && {
          clip_campaign: "Please select the campaign",
        }),

        ...(!isUnlimited && isEmpty && {
          clip_contacts: "Please select the contacts",
        }),

        ...(!isUnlimited && !isEmpty && !isValidNumber && {
          clip_contacts: "Impressions must be a positive number or 1",
        }),

        ...(usedFor === "add" && acceptedFiles.length === 0 && {
          clip_file: "Please select the clip file",
        }),
      });

      toast("Please fill in valid information", { type: "error" });
      return;
    }

    setBatchLoadingStatus(true);
    try {
      if (!currentStateData.new_clip_data.clip_optimized) {
        getStoresAvailableHours(
          currentStateData.selected_store_options.map((s) => s.id),
          getWeekdaysInRange(
            currentStateData.new_clip_data?.clip_start_date,
            currentStateData.new_clip_data?.clip_end_date
          ).map((day) => day.label)
        );
      }

      await new Promise(resolve => setTimeout(resolve, 1000));

      saveClipsInformation(usedFor, acceptedFiles, showSuccessMessage).then((info) => {
        if (info.success === false) {
          if (info.errorMessages !== "") {
            setFieldErrors(info.errorMessages);
          }
        } else {
          const successMessage =
            shouldClosePopup === true ? "Visual stopped successfully" : "Visual continued successfully";

          if (showSuccessMessage === false) {
            toast(successMessage, { type: "success" });
          }

          if (shouldClosePopup === true) {
            closeModal();
          }
        }
      }).finally(() => setBatchLoadingStatus(false));

    } catch {
      setBatchLoadingStatus(false);
    }
  };

  function getWeekdaysInRange(startDate, endDate) {
    if (!startDate || !endDate) return [];

    startDate = formatToStandardDate(startDate);
    endDate = formatToStandardDate(endDate);

    const daysInSelectedTimeperiod = Math.round((endDate - startDate) / (1000 * 3600 * 24) + 1);

    // Check if the selected period is atleast than 7 days
    if (daysInSelectedTimeperiod <= 7) {
      const date = new Date(startDate.getTime());
      const weekDayNumbersInRange = [];
      const weekDayNamesAccordingToNumbers = [];

      while (date <= endDate) {
        weekDayNumbersInRange.push(date.getDay()); //JS standard 0 = Sunnday has to be converted
        date.setDate(date.getDate() + 1);
      }

      const weekDayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      weekDayNumbersInRange.forEach((day) => {
        weekDayNamesAccordingToNumbers.push(weekDayNames[day]);
      });

      // Filter allWeekDayOptions to only include days in the date range
      return allWeekDayOptions.filter((option) =>
        weekDayNamesAccordingToNumbers.includes(option.label)
      );
    } else {
      return allWeekDayOptions;
    }
  }

  // Helper function: Returns weekdays that exist in selected calendar weeks
  const getWeekdaysInSelectedWeeks = () => {
    const selectedWeeks = currentStateData.new_clip_data?.clip_weeks || [];
    const startDate = currentStateData.new_clip_data?.clip_start_date;
    const endDate = currentStateData.new_clip_data?.clip_end_date;

    // If no weeks selected or no dates, return empty
    if (selectedWeeks.length === 0 || !startDate || !endDate) {
      return [];
    }

    const start = formatToStandardDate(startDate);
    const end = formatToStandardDate(endDate);

    // IMPORTANT: Our system uses 0 = Monday, not JavaScript's 0 = Sunday
    const weekDayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const daysInSelectedWeeks = new Set();

    // Iterate through each day in date range
    const currentDate = new Date(start);
    while (currentDate <= end) {
      // Get ISO week number for this day
      const weekNum = moment(currentDate).isoWeek();

      // If this week is selected, add the weekday
      if (selectedWeeks.includes(weekNum)) {
        // Convert JavaScript day (0=Sunday) to our format (0=Monday)
        const jsDay = currentDate.getDay(); // 0=Sunday, 1=Monday, etc.
        const dayName = weekDayNames[jsDay];
        daysInSelectedWeeks.add(dayName);
      }

      currentDate.setDate(currentDate.getDate() + 1);
    }

    // Convert Set to array of weekday options
    return allWeekDayOptions.filter(opt => daysInSelectedWeeks.has(opt.label));
  };

  const getCombinedWeekdayOptions = () => {
    const startDate = currentStateData.new_clip_data?.clip_start_date;
    const endDate = currentStateData.new_clip_data?.clip_end_date;

    if (!startDate || !endDate) {
      return [];
    }

    //Days form start/end
    const dateRangeWeekdays = getWeekdaysInRange(startDate, endDate);

    if (dateRangeWeekdays.length === 0) {
      return [];
    }

    // Store-Openingdays from API
    const apiWeekdays = weekdayOptions.length > 0 ? weekdayOptions : allWeekDayOptions;

    // Weeks from field
    const selectedWeeks = currentStateData.new_clip_data?.clip_weeks || [];

    let effectiveDateDays;

    if (selectedWeeks.length > 0) {
      const weekFilteredDays = getWeekdaysInSelectedWeeks();
      effectiveDateDays = dateRangeWeekdays.filter(dateDay =>
        weekFilteredDays.some(weekDay => weekDay.label === dateDay.label)
      );
    } else {
      effectiveDateDays = dateRangeWeekdays;
    }

    return effectiveDateDays.filter(dateDay =>
      apiWeekdays.some(apiDay => apiDay.label === dateDay.label)
    );
  };

  // Tracks whether clip data has been initialized to prevent re-running on subsequent campaignDatesList updates
  const clipDataInitializedRef = React.useRef(false);

  // Reset initialization flag on unmount to handle React StrictMode's double-invoke behavior
  React.useEffect(() => {
    return () => {
      clipDataInitializedRef.current = false;
    };
  }, []);

  React.useEffect(() => {
    const initializeClipForm = async () => {

      try {
        if (usedFor === "update") {
          const campaignNamesResult = await fetchCampaignNames();

          await Promise.all([
            loadCampaignsForUsers(clipInfo.clip_company_id),
            loadActivStoresFromCampaign(clipInfo.campaign_id),
            getStoresAvailableHours(clipInfo.selected_store_options.map((s) => s.id)),
            getStoresAvailableHours(
              clipInfo.selected_store_options.map((s) => s.id),
              clipInfo.selected_days
            ),
          ]);

          const clipStatus = checkStatus(clipInfo.start_date, clipInfo.end_date);
          calculateWeeks({
            clip_start_date: formatToStandardDate(clipInfo.start_date),
            clip_end_date: formatToStandardDate(clipInfo.end_date),
          });

          const campaignDates = campaignNamesResult.success && campaignNamesResult.data?.campaign_dates_list
            ? campaignNamesResult.data.campaign_dates_list[clipInfo.campaign_id]
            : null;

          handleFieldChange({
            id: clipInfo.id,
            content_name: clipInfo.name,
            campaign_name: clipInfo.campaign,
            campaign_id: clipInfo.campaign_id,
            clip_start_date: formatToStandardDate(clipInfo.start_date),
            clip_end_date: formatToStandardDate(clipInfo.end_date),
            campaign_start_date: campaignDates?.campaign_start_date,
            campaign_end_date: campaignDates?.campaign_end_date,
            clip_weeks: clipInfo.selected_weeks,
            clip_week_days: clipInfo.selected_days,
            clip_week_day_options: clipInfo.selected_days
              .map((dayLabel) => allWeekDayOptions.find((opt) => opt.label === dayLabel))
              .filter((opt) => opt !== undefined),
            clip_contacts: clipInfo.campaign_contacts,
            clip_volume: clipInfo.clip_volume,
            clip_unlimited: clipInfo.clip_unlimited,
            clip_start_end_status: clipStatus,
            active: clipInfo.active,
            hours: clipInfo.hours,
          });

          if (campaignDates?.campaign_start_date) {
            setClipStartDateConstraint(campaignDates.campaign_start_date);
          }

          clipDataInitializedRef.current = true;
        } else {
          await Promise.all([
            fetchCampaignNames(),
            loadCampaignsForUsers(),
          ]);

          let defaultVals = {
            clip_unlimited: false,
            clip_optimized: false,
            clip_volume: "190",
          };

          if (userInfo.user_type === "cyreen") {
            if (typeof currentStateData.independent_owners_list !== "undefined") {
              let data = currentStateData.independent_owners_list.find((owner) =>
                owner.label.includes("Cyreen")
              );
              if (data !== undefined) {
                defaultVals = {
                  ...defaultVals,
                  clip_owner: data.label,
                  clip_owner_id: data.id,
                };
              }
            }
          }
          handleFieldChange(defaultVals);
        }
      } catch {
      }
    };

    initializeClipForm();
  }, []);

  // Optimized is not saved in BE this Effect checks if optimized should be on when updating a Clip
  React.useEffect(() => {
    // only run for update mode
    if (usedFor !== "update") {
      return;
    }

    // skip if clip data is not loaded yet
    if (typeof currentStateData.new_clip_data === "undefined" || !currentStateData.new_clip_data?.id) {
      return;
    }

    // skip if clip_optimized was already derived (prevent re-running)
    if (typeof currentStateData.new_clip_data.clip_optimized !== "undefined") {
      return;
    }

    // skip if unlimited is enabled
    if (currentStateData.new_clip_data.clip_unlimited === true) {
      handleFieldChange({ clip_optimized: false });
      return;
    }

    // wait until hours options are loaded
    if (hoursOptions.length === 0) {
      return;
    }

    // wait until weekday options are loaded from API
    if (weekdayOptions.length === 0) {
      return;
    }

    // wait until campaign weeks are loaded
    if (typeof currentStateData.campaign_weeks === "undefined" || currentStateData.campaign_weeks.length === 0) {
      return;
    }

    // -------- check if all available options are selected (= default/not optimized) --------

    // Use actual available weekdays from API - no fallback needed since we wait for it above
    const availableWeekDays = getCombinedWeekdayOptions();

    // If no weekdays available (dates not set or no overlap), skip derivation
    if (availableWeekDays.length === 0) {
      return;
    }
    // get selected values
    const selectedDays = currentStateData.new_clip_data.clip_week_days || [];
    const selectedHours = currentStateData.new_clip_data.hours || [];
    const selectedWeeks = currentStateData.new_clip_data.clip_weeks || [];

    // get available options (exclude "all" option)
    const availableHours = hoursOptions.filter(o => o.value !== "all").map(o => o.value);
    const availableWeeks = currentStateData.campaign_weeks.filter(w => w.value !== "all").map(w => w.value);

    // check if all available options are selected (= default behavior, not optimized)
    const hasAllDays = availableWeekDays.length === 0 ||
      (selectedDays.length >= availableWeekDays.length &&
        availableWeekDays.every(day => selectedDays.includes(day.label)));

    const hasAllHours = availableHours.length === 0 ||
      (selectedHours.length >= availableHours.length &&
        availableHours.every(hour => selectedHours.includes(hour)));

    const hasAllWeeks = availableWeeks.length === 0 ||
      (selectedWeeks.length >= availableWeeks.length &&
        availableWeeks.every(week => selectedWeeks.includes(week)));

    // clip is optimized if NOT all available options are selected
    const derivedOptimized = !(hasAllDays && hasAllHours && hasAllWeeks);

    handleFieldChange({ clip_optimized: derivedOptimized });

  }, [hoursOptions, weekdayOptions, currentStateData.campaign_weeks, currentStateData.new_clip_data?.id]);

  // -------- effect: handle store selection changes --------
  React.useEffect(() => {
    // skip if selected_store_options is undefined (initial load)
    if (typeof currentStateData.selected_store_options === "undefined") {
      return;
    }

    // fetch available hours for selected stores
    if (currentStateData.selected_store_options.length > 0) {
      getStoresAvailableHours(currentStateData.selected_store_options.map((s) => s.id))
      getStoresAvailableHours(currentStateData.selected_store_options.map((s) => s.id), currentStateData.new_clip_data?.clip_week_days || clipInfo?.selected_days || []);
    }

    // only disable optimized if:
    // 1. stores array exists but is empty (user deselected all)
    // 2. AND optimized was previously enabled
    if (
      currentStateData.selected_store_options.length === 0 &&
      currentStateData.new_clip_data?.clip_optimized === true
    ) {
      handleFieldChange({
        clip_optimized: false,
      });
    }
  }, [currentStateData.selected_store_options]);

  // -------- effect: reload hours when weekdays change --------
  React.useEffect(() => {
    if (typeof currentStateData.selected_store_options === "undefined" ||
      currentStateData.selected_store_options.length === 0) {
      return;
    }
    const selectedDays = currentStateData.new_clip_data?.clip_week_days || [];
    getStoresAvailableHours(
      currentStateData.selected_store_options.map((s) => s.id),
      selectedDays
    );
  }, [currentStateData.new_clip_data?.clip_week_days]);

  // -------- effect: process available hours from API --------
  React.useEffect(() => {
    if (!currentStateData.stores_available_hours) {
      setHoursOptions([]);
      return;
    }

    const openedHours = currentStateData.stores_available_hours;

    if (!Array.isArray(openedHours) || openedHours.length === 0) {
      setHoursOptions([]);
      return;
    }

    const tempOptions = openedHours.map((h) => {
      const start = String(h).padStart(2, "0");
      return { value: h, label: `${start}:00 - ${start}:59` };
    });

    setHoursOptions(tempOptions);

  }, [currentStateData.stores_available_hours]);

  // -------- effect: process available weekdays from API --------
  React.useEffect(() => {
    if (!currentStateData.stores_available_weekdays) {
      setWeekdayOptions([]);
      return;
    }
    let availableWeekdayIndices;

    if (Array.isArray(currentStateData.stores_available_weekdays)) {
      availableWeekdayIndices = currentStateData.stores_available_weekdays;
    } else if (currentStateData.stores_available_weekdays.availableWeekdays) {
      availableWeekdayIndices = currentStateData.stores_available_weekdays.availableWeekdays;
    } else {
      availableWeekdayIndices = [];
    }

    if (!Array.isArray(availableWeekdayIndices) || availableWeekdayIndices.length === 0) {
      setWeekdayOptions([]);
      return;
    }

    // Map weekday indices to weekday options
    const weekdayIndexToName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    const tempWeekdayOptions = availableWeekdayIndices
      .map(index => {
        const dayName = weekdayIndexToName[index];
        return allWeekDayOptions.find(opt => opt.label === dayName);
      })
      .filter(opt => opt !== undefined);

    setWeekdayOptions(tempWeekdayOptions);

  }, [currentStateData.stores_available_weekdays]);

  // -------- effect: remove selected weekdays that are no longer available --------
  React.useEffect(() => {
    // Skip if dates are not set
    const clipData = currentStateData.new_clip_data;
    if (!clipData?.clip_start_date || !clipData?.clip_end_date) {
      return;
    }

    // Reset weekdays if date changed
    const startDateChanged = (clipData.clip_start_date?.getTime?.() ?? null) !== (prevClipStartDateRef.current?.getTime?.() ?? null);
    const endDateChanged = (clipData.clip_end_date?.getTime?.() ?? null) !== (prevClipEndDateRef.current?.getTime?.() ?? null);
    const dateChanged = startDateChanged || endDateChanged;

    if (dateChanged) {
      handleFieldChange({
        clip_week_days: [],
        clip_week_day_options: [],
      });

      // Update refs to current dates
      prevClipStartDateRef.current = clipData.clip_start_date;
      prevClipEndDateRef.current = clipData.clip_end_date;
      return; // Exit early, no need to validate old selections
    }

    // Skip if no weekdays are selected
    if (!clipData.clip_week_days || clipData.clip_week_days.length === 0) {
      return;
    }

    // Use combined options (includes date range, weeks, and API constraints)
    const availableOptions = getCombinedWeekdayOptions();
    const availableDayLabels = availableOptions.map(opt => opt.label);

    const currentSelectedDays = clipData.clip_week_days || [];
    const currentSelectedDayOptions = clipData.clip_week_day_options || [];

    const validDays = currentSelectedDays.filter(day => availableDayLabels.includes(day));
    const validDayOptions = currentSelectedDayOptions.filter(opt => availableDayLabels.includes(opt.label));

    // Only update if something changed
    if (validDays.length !== currentSelectedDays.length) {
      handleFieldChange({
        clip_week_days: validDays,
        clip_week_day_options: validDayOptions,
      });
    }
  }, [
    weekdayOptions,
    currentStateData.new_clip_data?.clip_week_days,
    currentStateData.new_clip_data?.clip_start_date,
    currentStateData.new_clip_data?.clip_end_date,
  ]);

  // -------- effect: remove selected hours that are no longer available --------
  React.useEffect(() => {
    // Skip if no hours are selected or no options loaded yet
    if (!currentStateData.new_clip_data?.hours ||
      currentStateData.new_clip_data.hours.length === 0 ||
      hoursOptions.length === 0) {
      return;
    }

    const availableHourValues = hoursOptions.map(opt => opt.value);
    const currentSelectedHours = currentStateData.new_clip_data.hours || [];

    // Filter out hours that are no longer available
    const validHours = currentSelectedHours.filter(hour => availableHourValues.includes(hour));

    // Only update if something changed
    if (validHours.length !== currentSelectedHours.length) {
      handleFieldChange({
        hours: validHours,
      });
    }
  }, [hoursOptions, currentStateData.new_clip_data?.hours]);

  // -------- effect: clean up weekdays when selected weeks change --------
  React.useEffect(() => {
    // Skip if no weeks or weekdays selected
    if (!currentStateData.new_clip_data?.clip_weeks ||
      currentStateData.new_clip_data.clip_weeks.length === 0 ||
      !currentStateData.new_clip_data?.clip_week_days ||
      currentStateData.new_clip_data.clip_week_days.length === 0) {
      return;
    }

    // Get the combined available options (includes week filter now)
    const availableOptions = getCombinedWeekdayOptions();
    const availableDayLabels = availableOptions.map(opt => opt.label);

    const currentSelectedDays = currentStateData.new_clip_data.clip_week_days || [];
    const currentSelectedDayOptions = currentStateData.new_clip_data.clip_week_day_options || [];

    // Filter out days that are no longer available
    const validDays = currentSelectedDays.filter(day => availableDayLabels.includes(day));
    const validDayOptions = currentSelectedDayOptions.filter(opt => availableDayLabels.includes(opt.label));

    // Only update if something changed
    if (validDays.length !== currentSelectedDays.length) {
      handleFieldChange({
        clip_week_days: validDays,
        clip_week_day_options: validDayOptions,
      });
    }
  }, [currentStateData.new_clip_data?.clip_weeks]);

  return (
    <>
      <Dialog
        open={open}
        onClose={(e) => {
          e.preventDefault();
        }}
        fullWidth={true}
        maxWidth={size}
      >
        <DialogTitle>{usedFor === "update" ? "Edit : " + clipInfo?.name : "Add Contact-based Visual"} </DialogTitle>
        <DialogContent>
          <StyledMainBox component="main">
            <Box>
              {/* ------- file upload (only visible for "Add Clip" or If Updating a scheduled clip) -------- */}
              {usedFor === "add" ||
                (typeof currentStateData.new_clip_data !== "undefined" &&
                  typeof currentStateData.new_clip_data.clip_start_end_status !== "undefined" &&
                  ["Scheduled"].includes(currentStateData.new_clip_data.clip_start_end_status)) ? (
                <Stack direction="row" spacing={2}>
                  <Box
                    {...getRootProps({ className: "dropzone" })}
                    height={60}
                    width="100%"
                    sx={{
                      border: "2px dashed #888",
                      padding: "20px",
                      textAlign: "center",
                      borderRadius: "12px",
                      cursor: "pointer",
                    }}
                  >
                    <input {...getInputProps()} />
                    <Box mt={1}>
                      <Typography variant="body3" sx={{ margin: "20px" }}>
                        Drag & Drop to Upload File or Click to Browse
                      </Typography>
                      <Box height={4} />
                      <Typography variant="body2">
                        <em>.mp4 (max. 1920x1080px)</em>
                      </Typography>
                    </Box>
                  </Box>
                </Stack>
              ) : typeof currentStateData.new_clip_data !== "undefined" &&
                typeof currentStateData.new_clip_data.clip_start_end_status !== "undefined" &&
                ["Active"].includes(currentStateData.new_clip_data.clip_start_end_status) ? (
                <>
                  {
                    currentStateData.new_clip_data.active === true ? (<DarkRedActionButton
                      component="label"
                      variant="contained"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowPlayoutStopConfirmation(true);
                      }}
                      startIcon={<BlockOutlined />}
                    >
                      Stop Playout
                    </DarkRedActionButton>) : (<DarkRedActionButton
                      component="label"
                      variant="contained"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowContinuePlayoutConfirmation(true);
                      }}
                      startIcon={<PlayArrow />}
                    >
                      Continue Playout
                    </DarkRedActionButton>)
                  }
                </>
              ) : (
                <LightGreyActionButton component="label" variant="contained" startIcon={<BlockOutlined />}>
                  Stop Playout
                </LightGreyActionButton>
              )}
              {/* ------- error message ------ */}
              {typeof fieldErrors.clip_file !== "undefined" && fieldErrors.clip_file !== "" && (
                <ErrorMessageText message={fieldErrors.clip_file} />
              )}
              {/* Accepted Files */}
              {acceptedFiles.length > 0 && (
                <Box mt={2}>
                  <h4>Accepted File</h4>
                  <ul>
                    {acceptedFiles.map((file, index) => (
                      <li key={`${file.name}-${index}`} style={{ marginTop: "5px" }}>
                        <Stack direction="row" spacing={2}>
                          <Typography variant="body2">
                            {file.name}
                          </Typography>
                        </Stack>
                      </li>
                    ))}
                  </ul>
                </Box>
              )}

              {/* Rejected Files */}
              {(rejectedFiles.length > 0 || invalidFiles.length !== 0 || resolutionErrors.length > 0) && (
                <Box mt={2}>
                  <h4>Rejected File</h4>
                  <ul>
                    {rejectedFiles.map((file, index) => (
                      <li key={`${file.name}-${index}`} style={{ marginTop: "5px" }}>
                        <Stack direction={"row"} spacing={2}>
                          <Box width={350} sx={{ wordWrap: "break-word" }}>
                            <Typography variant="body2">
                              {file.name}
                            </Typography>
                          </Box>
                          <Box width={450}>
                            <StyledDarkRedInformationTypography variant="body2">
                              :{" "}{
                                file.size > maxFileSize ? "File size exceeds the limit of 200 MB" : "Invalid file type. Allowed types are: .mp4"
                              }

                            </StyledDarkRedInformationTypography>
                          </Box>

                        </Stack>
                      </li>
                    ))}

                    {/* duplicated files */}
                    {invalidFiles.map((file, index) => (
                      <li key={`${file.name}-${index}`} style={{ marginTop: "5px" }}>
                        <Stack direction={"row"} spacing={2}>
                          <Box width={350} sx={{ wordWrap: "break-word" }}>
                            <Typography variant="body2">
                              {file.name}
                            </Typography>
                          </Box>
                          <Box width={450}>
                            <StyledDarkRedInformationTypography variant="body2">
                              :{" "}{"Invalid file name. The file name should only contain a-z, A-Z, 0-9, -, or _"}
                            </StyledDarkRedInformationTypography>
                          </Box>

                        </Stack>
                      </li>
                    ))}

                    {/* Resolution errors */}
                    {resolutionErrors.map((item, index) => (
                      <li key={`${item.file.name}-${index}`} style={{ marginTop: "5px" }}>
                        <Stack direction={"row"} spacing={2}>
                          <Box width={350} sx={{ wordWrap: "break-word" }}>
                            <Typography variant="body2">
                              {item.file.name}
                            </Typography>
                          </Box>
                          <Box width={450}>
                            <StyledDarkRedInformationTypography variant="body2">
                              : {item.message}
                            </StyledDarkRedInformationTypography>
                          </Box>

                        </Stack>
                      </li>
                    ))}
                  </ul>
                </Box>
              )}

              <Box height={35} />
              {/* -------- campaign selection ---------- */}
              <Stack direction={"row"} spacing={4}>
                {/* ---------- owner selection -------- */}
                {
                  userInfo.user_type === "cyreen" && usedFor !== "update" && (
                    <SingleSelect
                      label="Owner *"
                      enableFullWidth={true}
                      elemId={"ownerDropdown"}
                      options={
                        typeof currentStateData.independent_owners_list !== "undefined" ? Object.values(currentStateData.independent_owners_list) : []
                      }
                      selectionCheck={(option, value) => option?.id === value?.id}
                      defaultVal={
                        typeof currentStateData.new_clip_data !== "undefined" &&
                          typeof currentStateData.new_clip_data.clip_owner !== "undefined"
                          ? {
                            label: currentStateData.new_clip_data.clip_owner,
                            id: currentStateData.new_clip_data.clip_owner_id,
                          }
                          : ""
                      }
                      onChangeCall={(selectedOption) => {
                        dispatchAction(deleteItems(["new_clip_data", "selected_store_options", "campaign_stores_list", "filtered_stores", "filtered_regions", "stores_detail"]));
                        handleFieldChange({
                          clip_owner: selectedOption.label,
                          clip_owner_id: selectedOption.id
                        }, true);
                        let selectedOwnerId = !selectedOption.label.includes("Cyreen") ? selectedOption.id : "";
                        loadCampaignsForUsers(selectedOwnerId);
                      }}
                      fieldError={
                        typeof fieldErrors.clip_owner !== "undefined" && fieldErrors.clip_owner !== ""
                          ? fieldErrors.clip_owner
                          : ""
                      }
                    />
                  )
                }
                {/* -------- Select Campaign ------- */}
                <SingleSelect
                  label="Campaign *"
                  elemId={"clipsCampaignList"}
                  enableFullWidth={true}
                  options={campaignNameListOptions}
                  defaultVal={
                    typeof currentStateData.new_clip_data !== "undefined" &&
                      typeof currentStateData.new_clip_data.campaign_name !== "undefined"
                      ? {
                        id: currentStateData.new_clip_data.campaign_id,
                        label: currentStateData.new_clip_data.campaign_name,
                      }
                      : ""
                  }
                  selectionCheck={(option, value) => option.id === value.id}
                  onChangeCall={(selectedOption) => {
                    let selectedData = {
                      campaign_id: selectedOption.id,
                      campaign_name: selectedOption.label,
                    };
                    if (campaignDatesList.length !== 0) {
                      selectedData = {
                        ...selectedData,
                        campaign_start_date: campaignDatesList[selectedOption.id].campaign_start_date,
                        campaign_end_date: campaignDatesList[selectedOption.id].campaign_end_date,
                      };
                    }
                    // setcurrentStateData.new_clip_data(selectedData);
                    handleFieldChange(selectedData);
                    setClipStartDateConstraint(campaignDatesList[selectedOption.id].campaign_start_date);
                    loadActivStoresFromCampaign(selectedOption.id);
                  }}
                  readOnlyFlag={
                    typeof currentStateData.new_clip_data !== "undefined" &&
                      typeof currentStateData.new_clip_data.clip_start_end_status !== "undefined" &&
                      ["Active", "Completed"].includes(currentStateData.new_clip_data.clip_start_end_status)
                      ? true
                      : false
                  }
                  fieldError={
                    typeof fieldErrors.clip_campaign !== "undefined" && fieldErrors.clip_campaign !== ""
                      ? fieldErrors.clip_campaign
                      : ""
                  }
                />
              </Stack>
              {/* ------- start/end date -------- */}

              {typeof currentStateData.new_clip_data !== "undefined" &&
                typeof currentStateData.new_clip_data.campaign_name !== "undefined" && (
                  <>
                    <Box height={35} />
                    <Stack direction={"row"} spacing={4}>
                      {/* ------ clip start date -------- */}
                      <DateInputField
                        fieldRequired={true}
                        elemId="startDate"
                        className="start_date_class"
                        label="Start Date "
                        fieldName="start_date"
                        minSelectable={minSelectableDateForClip}
                        maxSelectable={
                          typeof currentStateData.new_clip_data !== "undefined" &&
                          typeof currentStateData.new_clip_data.campaign_end_date !== "undefined" &&
                          formatToStandardDate(currentStateData.new_clip_data.campaign_end_date)
                        }
                        defaultVal={
                          typeof currentStateData.new_clip_data !== "undefined" &&
                            typeof currentStateData.new_clip_data.clip_start_date !== "undefined"
                            ? currentStateData.new_clip_data.clip_start_date
                            : ""
                        }
                        showlabel={false}
                        disabled={
                          typeof currentStateData.new_clip_data !== "undefined" &&
                            typeof currentStateData.new_clip_data.clip_start_end_status !== "undefined" &&
                            ["Active", "Completed"].includes(currentStateData.new_clip_data.clip_start_end_status)
                            ? true
                            : false
                        }
                        fieldError={
                          typeof fieldErrors.clip_start_date !== "undefined" && fieldErrors.clip_start_date !== ""
                            ? fieldErrors.clip_start_date
                            : ""
                        }
                        onChangeCall={(selectedDate) => {
                          if (currentStateData?.new_clip_data?.clip_unlimited === false && usedFor === "update") {
                            setEndDateConfirmation(true);
                          }
                          setStartDateConfirmation(moment(selectedDate).isSame(standardFormatToday()));

                          const selectedData = {
                            clip_start_date: selectedDate,
                          };
                          handleFieldChange(selectedData);
                          calculateWeeks({
                            ...currentStateData.new_clip_data,
                            clip_start_date: selectedDate,
                          });
                        }}
                        onWeekSelect={handleWeekSelect}
                        weekSelectionMinDate={weekSelectionMin}
                        weekSelectionMaxDate={weekSelectionMax}
                      />

                      {/* -------- clip end date ------- */}
                      <DateInputField
                        fieldRequired={true}
                        elemId="endDate"
                        label="End Date "
                        className="end_date_class"
                        fieldName="end_date"
                        defaultVal={
                          typeof currentStateData.new_clip_data !== "undefined" &&
                            typeof currentStateData.new_clip_data.clip_end_date !== "undefined"
                            ? currentStateData.new_clip_data.clip_end_date
                            : ""
                        }
                        showlabel={false}
                        disabled={
                          typeof currentStateData.new_clip_data !== "undefined" &&
                            typeof currentStateData.new_clip_data.clip_start_end_status !== "undefined" &&
                            (["Completed"].includes(currentStateData.new_clip_data.clip_start_end_status) || currentStateData.new_clip_data.active === false)
                            ? true
                            : false
                        }
                        minSelectable={(() => {
                          if (
                            currentStateData.new_clip_data &&
                            currentStateData.new_clip_data.clip_start_date &&
                            moment(currentStateData.new_clip_data.clip_start_date).isSameOrAfter(moment(), "day")
                          ) {
                            return currentStateData.new_clip_data.clip_start_date;
                          } else if (
                            currentStateData.new_clip_data &&
                            currentStateData.new_clip_data.clip_start_date &&
                            moment(currentStateData.new_clip_data.clip_start_date).isSameOrBefore(moment(), "day")
                          ) {
                            return minSelectableDateForClip;
                          } else if (
                            typeof currentStateData.new_clip_data !== "undefined" &&
                            typeof currentStateData.new_clip_data.campaign_start_date !== "undefined"
                          ) {
                            return minSelectableDateForClip;
                          } else {
                            return standardFormatToday();
                          }
                        })()}
                        maxSelectable={
                          typeof currentStateData.new_clip_data !== "undefined" &&
                          typeof currentStateData.new_clip_data.campaign_end_date !== "undefined" &&
                          formatToStandardDate(currentStateData.new_clip_data.campaign_end_date)
                        }
                        fieldError={
                          typeof fieldErrors.clip_end_date !== "undefined" && fieldErrors.clip_end_date !== ""
                            ? fieldErrors.clip_end_date
                            : ""
                        }
                        onChangeCall={(selectedDate) => {
                          if (currentStateData?.new_clip_data?.clip_unlimited === false && usedFor === "update") {
                            setEndDateConfirmation(true);
                          } else {
                            setEndDateConfirmation(false);
                          }

                          const selectedData = {
                            clip_end_date: selectedDate,
                          };
                          handleFieldChange(selectedData);
                          setTimeout(() => {
                            calculateWeeks({ ...currentStateData.new_clip_data, clip_end_date: selectedDate });
                          }, 1000);
                        }}
                        onWeekSelect={handleWeekSelect}
                        weekSelectionMinDate={weekSelectionMin}
                        weekSelectionMaxDate={weekSelectionMax}
                      />
                    </Stack>
                    {(showStartDateConfirmation || showEndDateConfirmation) && (
                      <>
                        {showStartDateConfirmation && (
                          <>
                            <Box height={20} />
                            <StyledInfoBox>
                              <Typography variant="body2">
                                This visual is scheduled to start today. If the store is already open, the visual will begin playing within the next hour. Be aware that data for today might be incomplete, affecting later reports.
                              </Typography>
                            </StyledInfoBox>
                          </>
                        )}

                        {showEndDateConfirmation && (
                          <>
                            <Box height={10} />
                            <StyledInfoBox>
                              <Typography variant="body2">
                                When adjusting the dates of an existing visual, please note that the impression target is not updated automatically.
                                Remember to manually adjust the impression target for this visual if needed.
                              </Typography>
                            </StyledInfoBox>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}

              {/* --------- impressions, volume and stores --------- */}
              <Box height={29} />
              <Stack direction={"row"} spacing={4}>
                {/* --------- volume -------- */}
                <Box flex={1}>
                  <TextInputField
                    fieldRequired={true}
                    elemId="volume"
                    label="Volume"
                    fieldName="volume"
                    readOnlyFlag={statusBasedReadOnly}
                    showlabel={true}
                    defaultVal={
                      typeof currentStateData.new_clip_data !== "undefined" &&
                        typeof currentStateData.new_clip_data.clip_volume !== "undefined"
                        ? currentStateData.new_clip_data.clip_volume
                        : ""
                    }
                    inputType={"text"}
                    fieldError={
                      typeof fieldErrors.clip_volume !== "undefined" && fieldErrors.clip_volume !== ""
                        ? fieldErrors.clip_volume
                        : ""
                    }
                    onChangeCall={(e) => {
                      e.preventDefault();
                      const selectedData = {
                        clip_volume: e.target.value,
                      };
                      handleFieldChange(selectedData);
                    }}
                    iconProps={{
                      endAdornment: (
                        <InputAdornment position="end" sx={{ marginRight: "15px" }}>
                          <HtmlTooltip
                            title={
                              <Box width={300}>
                                <Typography variant="body2">
                                  <strong>Volume Ranges:</strong> <br />
                                  <Box height={10} />
                                  <strong>{"> 200:"}</strong> Very loud, usually deterioration in sound quality <br />
                                  <Box height={5} />
                                  <strong>170 - 200: </strong> Normal loudness, usually high sound quality (recommended range) <br />
                                  <Box height={5} />
                                  <strong>{"< 170:"} </strong> Very quiet, usually too quiet for store environment <br />
                                </Typography>
                              </Box>
                            }
                          >
                            <IconButton>
                              <Info aria-label="volumeToolTip" />
                            </IconButton>
                          </HtmlTooltip>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>

                {/* ---------- stores selection ---------- */}
                {typeof currentStateData.campaign_stores_list !== "undefined" && (
                  <Box flex={1}>
                    {usedFor === "update" ? (
                      <StoreHierarchy
                        fieldNames={{ stores: "clip_stores" }}
                        readOnlyFlag={statusBasedReadOnly}
                        fieldError={
                          typeof fieldErrors.clip_stores !== "undefined" && fieldErrors.clip_stores !== ""
                            ? fieldErrors.clip_stores
                            : ""
                        }
                        selectionInfo={clipInfo}
                        setSelectionInfo={setClipInfo}
                        usedFor={"clips"}
                        actionName={usedFor}
                        setIsDetailSelectionModalOpen={setIsDetailSelectionModalOpen}
                      />) : (
                      <StoreHierarchy
                        fieldNames={{ stores: "clip_stores" }}
                        readOnlyFlag={statusBasedReadOnly}
                        fieldError={
                          typeof fieldErrors.clip_stores !== "undefined" && fieldErrors.clip_stores !== ""
                            ? fieldErrors.clip_stores
                            : ""
                        }
                        selectionInfo={storePreselection}
                        setSelectionInfo={setStorePreselection}
                        usedFor={"clips"}
                        actionName={usedFor}
                        setIsDetailSelectionModalOpen={setIsDetailSelectionModalOpen}
                      />)}
                  </Box>
                )}
              </Stack>
              {/* ----------- unlimited toggle --------- */}
              {typeof currentStateData.campaign_stores_list !== "undefined" ?
                <></>
                : <Box height={20} />}
              <Stack direction={"row"} spacing={4} sx={typeof currentStateData.campaign_stores_list !== "undefined" ? { ml: -0.9, mt: -2 } : { ml: -0.9 }}>
                {/* -------- unlimited ------- */}
                <HtmlTooltip
                  title={
                    currentStateData.new_clip_data?.clip_optimized
                      ? "Unlimited cannot be enabled while Optimized is active"
                      : ""
                  }
                  disableHoverListener={!currentStateData.new_clip_data?.clip_optimized}
                >
                  <FormControlLabel
                    sx={{ ml: 0 }}
                    control={
                      <StyledSwitch
                        disabled={
                          currentStateData.new_clip_data?.clip_optimized || statusBasedReadOnly
                        }
                        checked={
                          typeof currentStateData.new_clip_data !== "undefined" &&
                            typeof currentStateData.new_clip_data.clip_unlimited !== "undefined"
                            ? currentStateData.new_clip_data.clip_unlimited
                            : false
                        }
                        onChange={(e) => {
                          const selectedData = {
                            clip_unlimited: e.target.checked,
                          };
                          handleFieldChange(selectedData);
                        }}
                      />
                    }
                    label="Unlimited"
                  />
                </HtmlTooltip>

                {/* -------- optimized ------- */}
                <HtmlTooltip
                  title={
                    currentStateData.new_clip_data?.clip_unlimited
                      ? "Optimized cannot be enabled while Unlimited is active"
                      : (!currentStateData.selected_store_options || currentStateData.selected_store_options.length === 0)
                        ? "Select stores to enable this option"
                        : ""
                  }
                  disableHoverListener={
                    !currentStateData.new_clip_data?.clip_unlimited &&
                    currentStateData.selected_store_options?.length > 0
                  }
                >
                  <FormControlLabel
                    control={
                      <StyledSwitch
                        disabled={
                          currentStateData.new_clip_data?.clip_unlimited ||
                          statusBasedReadOnly ||
                          !currentStateData.selected_store_options ||
                          currentStateData.selected_store_options.length === 0
                        }
                        checked={
                          typeof currentStateData.new_clip_data !== "undefined" &&
                            typeof currentStateData.new_clip_data.clip_optimized !== "undefined"
                            ? currentStateData.new_clip_data.clip_optimized
                            : false
                        }
                        onChange={(e) => {
                          const selectedData = {
                            clip_optimized: e.target.checked,
                          };
                          handleFieldChange(selectedData);
                        }}
                      />
                    }
                    label="Optimized"
                  />
                </HtmlTooltip>
              </Stack>

              {/* --------- weeks, days and hour selection ---------- */}

              {(typeof currentStateData.new_clip_data !== "undefined" &&
                typeof currentStateData.new_clip_data.clip_unlimited !== "undefined" &&
                currentStateData.new_clip_data.clip_unlimited === false) &&
                (typeof currentStateData.new_clip_data !== "undefined" &&
                  typeof currentStateData.new_clip_data.clip_optimized !== "undefined" &&
                  currentStateData.new_clip_data.clip_optimized) ? (
                <>
                  <Box height={35} />
                  <Stack direction={"row"} spacing={4}>
                    {/* -------- weeks numbers ------- */}
                    <HtmlTooltip
                      title={datesNotSelected ? "Select dates to enable this option" : ""}
                      disableHoverListener={!datesNotSelected}
                    >
                      <Box sx={{ width: '100%' }}>
                        <NoSortMultiSelect
                          label="Calendar Weeks *"
                          elemId="clipWeekNum"
                          enableFullWidth={true}
                          readOnlyFlag={statusBasedReadOnly || datesNotSelected}
                          options={
                            typeof currentStateData.campaign_weeks !== "undefined" ? currentStateData.campaign_weeks : []
                          }
                          defaultVal={
                            typeof currentStateData.new_clip_data !== "undefined" &&
                              typeof currentStateData.new_clip_data.clip_weeks !== "undefined"
                              ? typeof currentStateData.campaign_weeks !== "undefined"
                                ? currentStateData.campaign_weeks.filter((weekInfo) => {
                                  return currentStateData.new_clip_data.clip_weeks.includes(weekInfo.value);
                                })
                                : []
                              : []
                          }
                          enableSearch={true}
                          selectionCheck={(option, value) => option.value === value.value}
                          onChangeCall={(selectedOption) => {
                            let selectedWeekNum = [];
                            // selectedOption.forEach((option) => {
                            //   selectedWeekNum.push(option.value);
                            // });

                            selectedOption.forEach((chosen) => {
                              if (chosen.value !== "all") {
                                selectedWeekNum.push(chosen.value);
                              } else {
                                currentStateData.campaign_weeks.forEach((week) => {
                                  if (week.value !== "all") {
                                    selectedWeekNum.push(week.value);
                                  }
                                });
                              }
                            });

                            const selectedData = {
                              clip_weeks: selectedWeekNum,
                            };
                            // setcurrentStateData.new_clip_data(selectedData);
                            handleFieldChange(selectedData);
                          }}
                          fieldError={
                            typeof fieldErrors.clip_weeks !== "undefined" && fieldErrors.clip_weeks !== ""
                              ? fieldErrors.clip_weeks
                              : ""
                          }
                        />
                      </Box>
                    </HtmlTooltip>

                    {/* --------- week days -------- */}
                    <HtmlTooltip
                      title={(() => {
                        // No dates selected
                        if (datesNotSelected) {
                          return "Select dates to enable this option";
                        }

                        // Dates selected but no weekday options available
                        if (getCombinedWeekdayOptions().length === 0) {
                          return "No available weekdays found. The selected stores are not open during the campaign period.";
                        }

                        // Everything OK
                        return "";
                      })()}
                      disableHoverListener={!datesNotSelected && getCombinedWeekdayOptions().length > 0}
                    >
                      <Box sx={{ width: '100%' }}>
                        <NoSortMultiSelect
                          label="Weekdays *"
                          elemId="clipWeekDays"
                          readOnlyFlag={statusBasedReadOnly || datesNotSelected || getCombinedWeekdayOptions().length < 1}
                          enableFullWidth={true}
                          enableSearch={true}
                          options={getCombinedWeekdayOptions()}
                          defaultVal={
                            typeof currentStateData.new_clip_data !== "undefined" &&
                              typeof currentStateData.new_clip_data.clip_week_day_options !== "undefined"
                              ? // ? currentStateData.new_clip_data.clip_week_day_options
                              currentStateData.new_clip_data.clip_week_day_options
                              : []
                          }
                          selectionCheck={(option, value) => option.value === value.value}
                          onChangeCall={(selectedOption) => {
                            let selectedDays = [];
                            let selectedWeekDays = [];
                            selectedOption.forEach((day) => {
                              if (day.value === "all") {
                                allWeekDayOptions.forEach((weekDay) => {
                                  if (weekDay.value !== "all") {
                                    selectedDays.push(weekDay.label);
                                    selectedWeekDays.push(weekDay);
                                  }
                                });
                              } else {
                                selectedDays.push(day.label);
                                selectedWeekDays = selectedOption;
                              }
                            });

                            const selectedData = {
                              clip_week_days: selectedDays,
                              clip_week_day_options: selectedWeekDays,
                            };
                            // setcurrentStateData.new_clip_data(selectedData);
                            handleFieldChange(selectedData);
                          }}
                          fieldError={
                            typeof fieldErrors.clip_week_days !== "undefined" && fieldErrors.clip_week_days !== ""
                              ? fieldErrors.clip_week_days
                              : ""
                          }
                        />
                      </Box>
                    </HtmlTooltip>
                  </Stack>
                  {/* -------- hours ------- */}
                  <Box height={35} />
                  <Stack direction={"row"} spacing={4}>
                    <HtmlTooltip
                      title={
                        datesNotSelected
                          ? "Select dates and weekdays to enable this option"
                          : (!currentStateData.new_clip_data?.clip_week_days ||
                            currentStateData.new_clip_data.clip_week_days.length === 0)
                            ? "Please select weekdays first to enable hours selection"
                            : ""
                      }
                      disableHoverListener={
                        !datesNotSelected &&
                        currentStateData.new_clip_data?.clip_week_days &&
                        currentStateData.new_clip_data.clip_week_days.length > 0
                      }
                    >
                      <Box sx={{ width: '100%' }}>
                        <NoSortMultiSelect
                          label="Hours of Day *"
                          elemId={"hoursOfDay"}
                          enableSearch={true}
                          options={hoursOptions}
                          defaultVal={
                            currentStateData?.new_clip_data?.hours
                              ? hoursOptions.filter(o => currentStateData.new_clip_data.hours.includes(o.value))
                              : []
                          }
                          selectionCheck={(option, value) => option.value === value.value}
                          enableFullWidth={true}
                          readOnlyFlag={
                            statusBasedReadOnly ||
                            !currentStateData.new_clip_data?.clip_week_days ||
                            currentStateData.new_clip_data.clip_week_days.length === 0 ||
                            datesNotSelected
                          }
                          onChangeCall={(selectedOption) => {
                            const selectedData = {
                              hours: selectedOption.map(so => so.value)
                            };
                            handleFieldChange(selectedData);
                          }}
                          fieldError={
                            typeof fieldErrors.hours !== "undefined" && fieldErrors.hours !== ""
                              ? fieldErrors.hours
                              : ""
                          }
                        />
                      </Box>
                    </HtmlTooltip>
                    <TextInputField
                      fieldRequired={true}
                      elemId="campaignContacts"
                      label="Impressions"
                      fieldName="campaign_contacts"
                      readOnlyFlag={statusBasedReadOnly}
                      showlabel={true}
                      inputHeight={21} //Vertical alignment with Multiselect (because Inputheight is by def taller)
                      sx={{ pt: 0.58 }}
                      defaultVal={
                        typeof currentStateData.new_clip_data !== "undefined" &&
                          typeof currentStateData.new_clip_data.clip_contacts !== "undefined"
                          ? currentStateData.new_clip_data.clip_contacts
                          : ""
                      }
                      inputType={"text"}
                      fieldError={
                        typeof fieldErrors.clip_contacts !== "undefined" && fieldErrors.clip_contacts !== ""
                          ? fieldErrors.clip_contacts
                          : ""
                      }
                      onChangeCall={(e) => {
                        e.preventDefault();
                        const selectedData = {
                          clip_contacts: e.target.value,
                        };
                        // setcurrentStateData.new_clip_data(selectedData);
                        handleFieldChange(selectedData);
                      }}
                    />
                  </Stack>
                </>
              ) :
                (typeof currentStateData.new_clip_data !== "undefined" &&
                  typeof currentStateData.new_clip_data.clip_unlimited !== "undefined" &&
                  !currentStateData.new_clip_data.clip_unlimited && (
                    <TextInputField
                      fieldRequired={true}
                      elemId="campaignContacts"
                      label="Impressions"
                      fieldName="campaign_contacts"
                      readOnlyFlag={statusBasedReadOnly}
                      showlabel={true}
                      inputHeight={21} //Vertical alignment with Multiselect (because Inputheight is by def taller)
                      sx={{ mt: 0 }}
                      defaultVal={
                        typeof currentStateData.new_clip_data !== "undefined" &&
                          typeof currentStateData.new_clip_data.clip_contacts !== "undefined"
                          ? currentStateData.new_clip_data.clip_contacts
                          : ""
                      }
                      inputType={"text"}
                      fieldError={
                        typeof fieldErrors.clip_contacts !== "undefined" && fieldErrors.clip_contacts !== ""
                          ? fieldErrors.clip_contacts
                          : ""
                      }
                      onChangeCall={(e) => {
                        e.preventDefault();
                        const selectedData = {
                          clip_contacts: e.target.value,
                        };
                        // setcurrentStateData.new_clip_data(selectedData);
                        handleFieldChange(selectedData);
                      }}
                    />))}

              {/* ----------- last updated --------- */}
              <Box height={35} />
              <Stack direction={"row"} spacing={4}>
                {usedFor === "update" && (
                  <StyledDarkRedInformationTypography variant="body2">
                    Last Modified:
                    <StyledInformationSpan
                      style={{
                        color: "#2D2D37",
                        fontWeight: "bold",
                        marginLeft: "5px",
                      }}
                    >
                      {clipInfo.last_edit_by}
                    </StyledInformationSpan>
                  </StyledDarkRedInformationTypography>
                )}
              </Stack>
            </Box>
          </StyledMainBox>
        </DialogContent>
        <DialogActions>
          <Stack direction={"row"} spacing={2}>
            <CloseButton
              onClick={(e) => {
                e.preventDefault();
                closeModal();
              }}
              label="Cancel"
              icon={<Close />}
            />
            {/* save/update button is only visible for adding a new clip or while updating active or scheduled clip */}
            {usedFor === "add" ||
              (typeof currentStateData.new_clip_data !== "undefined" &&
                typeof currentStateData.new_clip_data.clip_start_end_status !== "undefined" &&
                ["Active", "Scheduled"].includes(currentStateData.new_clip_data.clip_start_end_status)) ? (
              <ActionButton
                onClick={(e) => {
                  e.preventDefault();
                  setFieldErrors({});
                  saveUpdpateClipInfo(true, true);
                }}
                label={usedFor === "update" ? "Update" : "Save"}
                icon={<Save />}
              />
            ) : (
              <></>
            )}
          </Stack>
        </DialogActions>
      </Dialog >
      {/* showPlayoutStopConfirmation
       */}
      {/* ------- stop playout confirmation -------- */}
      {
        showPlayoutStopConfirmation === true && (
          <Confirmation
            showConfirmationPopup={showPlayoutStopConfirmation}
            closePopup={(e) => {
              setShowPlayoutStopConfirmation(false);
            }}
            confirmationActionCall={() => {
              handleFieldChange({
                active: false, clip_end_date: standardFormatToday(),
              })
              saveUpdpateClipInfo(true, false);
            }}
            confirmationMessage={
              <>
                <Typography variant="body2">
                  Stopping the playout will immediately halt the distribution of this visual in all stores. No further campaign data will be collected, and the visual's end date will be set to today.
                </Typography>
                <Box height={10} />
                <Typography variant="body2">
                  Once confirmed, the visual will stop playing in all stores within approximately 15 minutes. You may restart the playout at any time before midnight. Afterwards, the visual expires permanently and cannot be resumed.
                </Typography>
                <Box height={10} />
                <Typography variant="body2">Do you want to proceed?</Typography>
              </>
            }
            confirmationTitle={"Stop Playout"}
          />
        )
      }

      {/* ------ continue playout confirmation ------ */}
      {
        showContinuePlayoutConfirmation === true && (
          <Confirmation
            showConfirmationPopup={showContinuePlayoutConfirmation}
            closePopup={(e) => {
              setShowContinuePlayoutConfirmation(false);
            }}
            confirmationActionCall={() => {
              handleFieldChange({
                active: true,
              })
              saveUpdpateClipInfo(false, false);
            }}
            confirmationMessage={
              <>
                <Typography variant="body2">
                  Continuing the playout will distribute the visual to all selected stores. Please remember to set a new end date.
                </Typography>
                <Box height={10} />
                <Typography variant="body2">
                  Once confirmed, the visual will begin playing in all stores within approximately 15 minutes.
                </Typography>
                <Box height={10} />
                <Typography variant="body2">Do you want to proceed?</Typography>
              </>
            }
            confirmationTitle={"Continue Playout"}
          />
        )
      }
      {
        usedFor === "update" ? (
          <DetailSearchContactBasedVisualStores
            open={isDetailSelectionModalOpen}
            onClose={() => setIsDetailSelectionModalOpen(false)}
            size="lg"
            clipInfo={clipInfo}
            usedFor={usedFor}
          />
        ) : (
          <DetailSearchContactBasedVisualStores
            open={isDetailSelectionModalOpen}
            onClose={() => setIsDetailSelectionModalOpen(false)}
            size="lg"
            clipInfo={storePreselection}
            usedFor={usedFor}
          />
        )
      }
    </>
  );
};

export default AddNewClip;
